<template>
  <div :class="[notfundweb?'module-wrapper-wap':'module-wrapper']"
  @touchmove.prevent v-if="showbottomView">
    <transition name="fade">
    <div v-if="!canHihen">
      <div class="userGuide"
      v-if="showGuid && guidText.length > 0"
      :style="`bottom:${binnerHeight+40}px;left:${leftgz}px;`" >
      <img src="@/assets/bottomguid.png"
               class="userGuideTri"
               :style="`left:${84 - trileftgz}px;`"
               alt="">
        <div class="userGuideCont" >
          <span class="userGuideText">{{guidText}}</span>
        </div>
        <div class="userGuideSep" >
        </div>
      </div>
    <p class="rate-tip linebottomg"
        v-if="showFeeLan" @click="tradeFund">
      <span>购买费率：</span>
      <span>{{!feeIsNull ? originFee : ""}}</span>
      <span>{{fee}}</span>
      <span class="rxe_tip" v-if="buyStatetip === ''">{{buypointtip}}</span>
      <span class="rxe_tip">{{buyStatetip}}</span>
    </p>
    <div class="panel">

      <div class="right-buttons">
        <div class="right-button" @click="clickBar()">
          <img src="@/assets/ef_fund_detail_bar.png"
               class="button-icon"
               alt="">
          <span class="button-label">讨论</span>
          <i class="red-dot" v-if="showBarGuid(closeBarGuid)" />
        </div>
        <div class="spline"></div>
        <div class="right-button" @click="clickPk" >
          <img src="@/assets/pk.png"
               class="button-icon"
               alt="">
          <span class="button-label">对比</span>
        </div>
        <div class="spline"></div>
        <div class="right-button" @click="clickSetOption">
          <img src="@/assets/follow.png"
               class="button-icon"
               v-if="!optionState"
               alt="">
          <img src="@/assets/ef_detail_set_option.png"
               class="button-icon"
               v-if="optionState"
               alt="">
          <span class="button-label">{{optionState?'设自选' : '加自选'}}</span>
        </div>
        <div class="spline"></div>
        <div class="right-button" @click="clickShowMore">
          <img src="@/assets/more.png"
               class="button-icon"
               alt="">
          <span class="button-label">更多</span>
        </div>
      </div>
      <div
        class="buy_single_text_content"
        :style="{'background-image': canNewBtnRed ?
        'linear-gradient(90deg, #FF9503 0%, #FF4400 100%)' :
        'linear-gradient(90deg, #cccccc 0%, #cccccc 100%)'}"
        @click="goNewFundBtnAction"
        v-if="isNewFund() && !isTS && loadfinish"
      >
        <div>
          {{sellStateText}}
        </div>
      </div>
      <div
        class="buy_single_text_content"
        :style="{'background-image': canCnClickBuy ?
        'linear-gradient(90deg, #FF9503 0%, #FF4400 100%)' :
        'linear-gradient(90deg, #cccccc 0%, #cccccc 100%)'}"
        @click="goCnFundBtnAction()"
        v-if="isExchangeFund() && !isTS && loadfinish && !isNewFund()"
      >
        <div>
          购买
        </div>
      </div>
      <div v-if="isNomalFund() && !isTS && isSale && loadfinish"
        :style="{'background-image': canFixedBuy ?
        'linear-gradient(270deg, #FFAD04 3%, #FFCC22 98%)' :
        'linear-gradient(90deg, #e0e0e0 0%, #cccccc 100%)'}"
       class="invest-button" @click="clickShowFixed" >定投</div>
      <div v-if="isNomalFund() && !isTS && isSale && loadfinish"
        :style="{'background-image': canClickBuy ?
        'linear-gradient(90deg, #FF9503 0%, #FF4400 100%)' :
        'linear-gradient(90deg, #c2c2c2 0%, #b8b8b8 100%)'}"
       class="buy-button" @click="clickShowBuy" >购买</div>
       <div v-if="!loadfinish"
       @click="clickEmpt"
      :style="{'background-image':'linear-gradient(90deg, #D6D6D6 2%, #C7C7C7 98%)'}"
      class="buy_single_text_content">状态加载中</div>
       <div v-if="isNomalFund() && !isSale && !isTS && loadfinish"
       @click="clickEmpt"
      :style="{'background-image':'linear-gradient(90deg, #D6D6D6 2%, #C7C7C7 98%)'}"
      class="buy_single_text_content">暂不销售</div>
      <div v-if="isTS && loadfinish"
      @click="clickEmpt"
      :style="{'background-image':'linear-gradient(90deg, #D6D6D6 2%, #C7C7C7 98%)'}"
      class="buy_single_text_content">暂不开放购买</div>
    </div>
    <div class="bottomsp" v-if="!webbottomshow" :style="`height:${binnerHeight}px`"></div>
    </div>
     </transition>
    <div class="mask" v-if="showPopup"></div>
    <transition name="slide-fade">
    <MyPopup
      v-if="showPopup"
      position="bottom"
      mode="fixed"
      :list="popupList"
      :tabSelected="0"
      @hidePopup="hidePopup"
      @clickPopup="clickPopup"
    ></MyPopup>
    </transition>
    <div class="mask" v-if="showMainPopup"></div>
    <transition name="slide-fade">
      <MorePopup
      v-if="showMainPopup"
      position="bottom"
      mode="fixed"
      :list="popupMoreList"
      :tabSelected="0"
      @hidePopup="hideMorePopup"
      @clickPopup="clickMorePopup"
      @cancelPopup="cancelPopup"
      ></MorePopup>
    </transition>
    <div class="mask" v-if="showbuyPopup"></div>
    <transition name="slide-fade">
    <BuyAlert
      v-if="showbuyPopup"
      position="bottom"
      mode="fixed"
      :title="popupBuyTitle"
      :list="popupBuyList"
      :tabSelected="0"
      @hidePopup="hideBuyPopup"
      @clickPopup="clickBuyPopup"
    ></BuyAlert>
    </transition>
    <div class="mask" v-if="resbottomView"></div>
      <ReitsPop
      v-if="resbottomView"
      position="bottom"
      mode="fixed"
      @hidePopup="hideRESPopup"
      @tipClick="clickResTip"
      @tipClick2="clickResTip2"
      @comfirmClick="clickResComfirm"
      @cancelPopup="cancelRes"
      ></ReitsPop>
  </div>
</template>

<script>

import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import cfhmr from '@/assets/ef_detail_more_b_cfhmr.png';
import jgjd from '@/assets/ef_detail_more_b_jgjd.png';
import twpng from '@/assets/ef_detail_more_b_twpng.png';
import ft from '@/assets/ef_detail_more_ft.png';
import bz from '@/assets/ef_detail_more_b_bz.png';
import znzl from '@/assets/ef_detail_more_b_znzl.png';
import dtjsj from '@/assets/ef_detail_more_dtjsj.png';
import zd from '@/assets/ef_detail_more_b_zd.png';
import fx from '@/assets/ef_detail_more_b_fx.png';
import JS from '@/base/JSTool';
// import { formatDate } from '@fund/basic-lib/dist/lib/date';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import {
  emBuyFund,
  setCalendarRemind,
  queryCalendarRemind,
  openCalendarRemind,
  getOptionFundState,
  deleteOptionFund,
  topOptionFund,
  shareFundDetail,
  userLogin,
} from '@/utils/nativeBridge';
import { getBottomSafeHeight } from '@fund/basic-lib/dist/lib/system';
import NativeMsg from '@/base/NativeMsg';
import MyPopup from './OptionView/Fund-popup.vue';
import MorePopup from './OptionView/Fund_morePop.vue';
import BuyAlert from './OptionView/Fund-buyAlert.vue';
import ReitsPop from './OptionView/Fund-ReitsPop.vue';

export default {
  name: 'OperationPanel',
  components: {
    MyPopup,
    MorePopup,
    BuyAlert,
    ReitsPop,
  },
  data() {
    return {
      binnerHeight: 0,
      canHihen: false,
      fundCode: '',
      fundType: '',
      isIphoneX: false,
      momentsIcon: '/static/images/icon-share-moments.png',
      buyButtonIcon: '/static/images/icon-buy-button.png',
      efdbpkIcon: '@/assets/pk.png',
      efdbaddIcon: '@/assets/follow.png',
      efdbsetIcon: '@/assets/ef_detail_set_option.png',
      efdbbarIcon: '@/assets/pk.png',
      efdbmoreIcon: '@/assets/more.png',
      canClickBuy: false, // 是否可以点击购买
      canFixedBuy: false, // 新发是否可以亮起来
      canCnClickBuy: false, // 场内是否可以点击购买
      canNewBtnRed: false, // 新发是否可以亮起来
      canSubscribe: false,
      originFee: '',
      isTS: false,
      fee: '',
      feeIsNull: false,
      launchAppParameter: '',
      hadcalendarremind: false,
      fundName: '',
      showPopup: false, // 是否显示自选选择框
      popupList: ['删自选', '设置提醒', '自选置顶'], // 自选选择框
      popupMoreList: [], // 跟多选择框
      popupBuyList: [],
      popupBuyTitle: { name: '--', link: {} },
      popupText: '更多',
      ftype: '',
      showMainPopup: false,
      optionState: false,
      isSale: true,
      baseInfo: {},
      cfhLink: {},
      cfhID: '',
      cfhName: '',
      cfhImgPath: '',
      cfhtip: '',
      shareDate: {},
      showbuyPopup: false,
      guidText: '',
      showGuid: false,
      closeBarGuid: false,
      needGetDateAlertState: false,
      loadfinish: false,
      buypointtip: '',
      buyStatetip: '',
      cfhtipKey: '',
      cfhtipmoreKey: '',
      showbottomView: true,
      showNewBuy: false,
      webbottomshow: false,
      sellStateText: '购买',
      credKey: '',
      showFeeLan: false,
      leftgz: 150,
      trileftgz: 80,
      isHold: false,
      notfundweb: false,
      resbottomView: false,
    };
  },
  computed: {
  },
  created() {
    // #if EXECUTION_ENV == 'web'
    this.notfundweb = true;
    // eslint-disable-next-line no-undef
    const webPlatf = multi.$system.webPlatform;
    if (webPlatf === 'wap') {
      this.webbottomshow = true;
    }
    // #endif
    NativeMsg.reg('refreshState', (res) => {
      if (res.state === 1) {
        this.canHihen = true;
      } else {
        this.canHihen = false;
      }
    });
    NativeMsg.reg('refreshNewState', () => {
      this.hideRate();
      this.getSellStateText();
    });
    NativeMsg.reg('reloadUserProfit', () => {
      this.configureHoldData();
    });
    NativeMsg.reg('onPageShow', () => {
      this.getFundOptionStateSetAfter();
    });
    NativeMsg.reg('share', () => {
      // console.log('zxy NativeMsg');
      this.shareClick();
      this.reportMonitor({
        eventName: 'pz.nav.more',
        infoCodeType: '',
        infoCode: '',
      });
    });
    NativeMsg.reg('appear', () => {
      // 环境差异，安卓需要在事件后拿下日历状态
      this.configureAlertState();
    });
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
    if (this.isNewFund()) {
      setTimeout(() => {
        this.render();
      }, 300);
    }
  },
  mounted() {
    // #if EXECUTION_ENV == 'web'
    this.binnerHeight = getBottomSafeHeight() / 2;
    // #endif
    // eslint-disable-next-line no-mixed-operators
    this.leftgz = (window.innerWidth - 200) / 2;
    // eslint-disable-next-line no-mixed-operators
    this.trileftgz = (window.innerWidth / 2.0) - ((window.innerWidth - 155 - 10) / 4.0 * 3.5);
    console.log(`sdadsa===${this.trileftgz}`);
  },
  methods: {
    jumpToBuyAPPFund() {
      // const baseInfo = StoreManger.getFundJJXQ();
      // const qdcode = baseInfo.FCODE;
      // const linkTo = `fund://page/funddetail?fundcode=${qdcode}&id=${qdcode}`;
      // multi.$router.push({
      //   type: 1,
      //   url: linkTo,
      // }, {
      //   // 第二个参数为h5页面跳转非项目内的页面参数
      //   url: '',
      //   wxmp: {
      //     url: `/pages/buy-fund/index?fundCode=${qdcode}`,
      //     openNewWindow: true,
      //   },
      // });
      this.jumpToAPPFund();
    },
    jumpToAPPFund() {
      const baseInfo = StoreManger.getFundJJXQ();
      const qdcode = baseInfo.FCODE;
      const linkTo = `fund://page/funddetail?fundcode=${qdcode}&id=${qdcode}`;
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        multi.$router.push({
          type: 1,
          url: linkTo,
        });
      } else {
        // multi.$router.push({
        //   type: 1,
        //   url: linkTo,
        // }, {
        //   url: `https://material.1234567.com.cn/low-code/e254683f706d14fbf26c0e965b7a6a47/index.html?schema=fund://mp.1234567.com.cn/weex/fundb5035dd2ee584a/pages/public-offer-fund/index?fundCode=${qdcode}`,
        // });
        multi.$router.push({
          type: 1,
          url: linkTo,
        });
      }
    },
    configureHoldData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const hdcode = baseInfo.BACKCODE;
      const qdcode = baseInfo.FCODE;
      const data = StoreManger.GetFundsProductProfit();
      let holdFund = false;
      if (data) {
        if (data.Data) {
          data.Data.forEach((element) => {
            if (element.FundCode === qdcode) {
              if (element.IsHolding) {
                holdFund = true;
              }
            }
            if (element.FundCode === hdcode) {
              if (element.IsHolding) {
                // holdFund = true; 后端
              }
            }
          });
        }
      }
      this.isHold = holdFund;
      this.configureBuypointtip();
    },
    getSellStateText() {
      if (this.isExchangeFund()) {
        this.sellStateText = '购买';
        return '购买';
      }
      // 0: 未开始 1: 进行中 2: 已结束
      const state = this.getfundStatus();
      if (state === 0) {
        if (this.hadcalendarremind) {
          this.sellStateText = '查看提醒';
          return '查看提醒';
        }
        if (this.baseInfo) {
          if (this.baseInfo.FINSALES) {
            if (this.baseInfo.FINSALES === '1') {
              this.sellStateText = '暂不销售';
              return '暂不销售';
            }
          }
        }
        this.sellStateText = '开售提醒';
        return '开售提醒';
      }
      if (state === 2) {
        this.sellStateText = '等待成立';
        return '等待成立';
      }
      if (state === 1) {
        this.sellStateText = '购买';
        return '购买';
      }
      this.sellStateText = '暂不开放购买';
      return '暂不开放购买';
    },
    configureName(item) {
      const SHORTNAME = JS.fetchString(item, 'SHORTNAME');
      this.fundName = SHORTNAME;
      this.getnewfundcalendarremind();
    },
    render() {
      this.configureBasInfo();
      this.getSellStateText();
      this.showFeeLan = !this.hideRate();
      this.loadfinish = true;
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.credKey = this.$store.state.native.fund.fundCode;
      this.getFundOptionState();
      const fundinfo = StoreManger.getFundJJXQ();
      if (fundinfo) {
        this.canCnClickBuy = true;
      }
      // 王强 不显示指引
      // #if EXECUTION_ENV === 'fund'
      this.guidText = this.getBottomGuidText();
      if (!isEmpty(this.guidText)) {
        this.showGuid = true;
        setTimeout(this.setClickBottomGuid, 5000);
      } else {
        this.showGuid = false;
      }
      // #endif
      const baseInfo = StoreManger.getFundJJXQ();
      if (baseInfo) {
        this.configureName(baseInfo);
        if (!isEmpty(baseInfo.TSRQ)) {
          const endDate = new Date(baseInfo.TSRQ.replace(/-/g, '/')).getTime();
          const serverDate = new Date().getTime();
          if (serverDate > endDate) {
            this.isTS = true;
            return;
          }
        }
        if (baseInfo.ISSALES === '0') {
          this.isTS = true;
        }
      }
      this.getSellStateText();

      const fundIdAll = this.$store.state.quotation.fund[
        `${this.fundCode}FundBarList`
      ];
      if (fundIdAll) {
        const fundId = fundIdAll.Data;
        if (!isEmpty(fundId)) {
          const item = fundId[0];
          if (item.PostId) {
            this.credKey = `${item.PostId}`;
          }
        }
      }
    },
    async configureBuypointtip() {
      const ishod = this.isHold;
      const fundinfo = StoreManger.getFundJJXQ();
      let buypoint = '';
      const ISSALES = JS.fetchString(fundinfo, 'ISSALES');
      const MINSG = JS.fetchString(fundinfo, 'MINSG');
      const MINSBSG = JS.fetchString(fundinfo, 'MINSBSG');
      if (ISSALES === '1' && !isEmpty(MINSG)) {
        if (`${parseFloat(MINSG).toFixed(0)}` !== '100') {
          buypoint = `购买起点：${parseFloat(MINSG).toFixed(0)}元`;
        }
      }
      if (ishod) {
        if (MINSG !== MINSBSG) {
          buypoint = `追加买入起点：${parseFloat(MINSBSG).toFixed(0)}元`;
        }
      }
      this.buypointtip = buypoint;

      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        this.buyStatetip = '';
        return;
      }
      const {
        SGZT, SHZT,
      } = baseInfo;
      if (SGZT === SHZT) {
        this.buyStatetip = SGZT;
      } else if (SGZT === '开放申购' && SHZT === '开放赎回') {
        this.buyStatetip = '';
      } else {
        this.buyStatetip = `${SGZT} ${SHZT}`;
      }
    },
    getlastpostid() {
      return this.credKey;
    },
    showBarGuid(close) {
      let selectItem = this.getlastpostid();
      if (!selectItem) {
        selectItem = `${this.fundCode}`;
      }

      if (close) {
        return false;
      }
      if (!this.getCache('guidBarKey')) {
        return true;
      }
      if (this.getCache('guidBarKey').indexOf(selectItem) !== -1) {
        return false;
      }
      return true;
    },

    setCache(key, value) {
      window.localStorage.setItem(key, value);
    },
    getCache(key) {
      return window.localStorage.getItem(key);
    },

    setClickBarGuide() {
      this.closeBarGuid = true;
      let cacheValue = '';
      let newc = this.getlastpostid();
      if (!newc) {
        newc = `${this.fundCode}`;
      }
      if (newc) {
        if (this.getCache('guidBarKey')) {
          if (this.getCache('guidBarKey').indexOf(newc) === -1) {
            cacheValue = `${this.getCache('guidBarKey')},${newc}`;
            this.setCache('guidBarKey', cacheValue);
            return true;
          }
          return true;
        }
        cacheValue = `${newc}`;
        this.setCache('guidBarKey', cacheValue);
        return true;
      }
      return true;
    },
    getTsState() {
      const TSRQ = JS.fetchString(this.baseInfo, 'TSRQ');
      const endDate = new Date(TSRQ.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();
      if (serverDate > endDate) {
        return true;
      }
      return false;
    },
    configureBasInfo() {
      this.baseInfo = StoreManger.getFundJJXQ();
      // this.baseInfo.BUY = false;
      // this.baseInfo.ISSALES = '0';
    },
    confiurenewBuy() {
      if (this.isExchangeFund()) {
        return;
      }
      const {
        ISSBDATE,
      } = this.baseInfo;
      if (!isEmpty(ISSBDATE)) {
        const stm = `${ISSBDATE}`;
        const startDate = new Date(stm).getTime();
        const serverDate = new Date().getTime();
        if ((startDate - serverDate) > (1000 * 60 * 60 * 1)
        || (serverDate - startDate) > (1000 * 60 * 60 * 1)) {
          if (this.sellStateText === '购买') {
            if (this.canNewBtnRed === true) {
              this.canNewBtnRed = false;
            }
          }
        }
      }
    },
    hideRate() {
      if (!this.baseInfo) {
        console.log('hideRate');
        return true;
      }
      const BUY = JS.fetchString(this.baseInfo, 'BUY');
      const DTZT = JS.fetchString(this.baseInfo, 'DTZT');
      const SOURCERATE = JS.fetchString(this.baseInfo, 'SOURCERATE');
      const RATE = JS.fetchString(this.baseInfo, 'RATE');
      const ISSALES = JS.fetchString(this.baseInfo, 'ISSALES');
      const SHORTNAME = JS.fetchString(this.baseInfo, 'SHORTNAME');
      const FTYPE = JS.fetchString(this.baseInfo, 'FTYPE');
      let buystate = true;
      if (this.baseInfo) {
        buystate = this.baseInfo.BUY;
      }
      this.canSubscribe = BUY;
      this.originFee = SOURCERATE;
      this.fee = RATE;
      this.canClickBuy = buystate;
      this.canFixedBuy = DTZT === '1';
      this.fundName = SHORTNAME;
      this.ftype = FTYPE;
      if (this.sellStateText === '购买' || this.sellStateText === '开售提醒') {
        this.canNewBtnRed = true;
      } else {
        this.canNewBtnRed = false;
      }
      if (buystate) {
        if (ISSALES !== '1') {
          this.canNewBtnRed = false;
        }
      } else {
        this.confiurenewBuy();
      }
      if (this.isExchangeFund() && this.isNewFund()) {
        this.canNewBtnRed = true;
      }
      this.feeIsNull = this.fee === null
        || this.fee === undefined
        || isEmpty(this.fee)
        || this.fee === '0%'
        || this.fee === '0.0%'
        || this.fee === '0.00%'
        || this.originFee === this.fee;

      const isPit = FundTypeSearch.isPit(this.fundType);
      const isClosed = FundTypeSearch.isClosed(this.fundType);

      this.isSale = isPit ? this.canSubscribe : ISSALES === '1';
      return isPit || isClosed || !this.isSale;
    },
    getFundOptionState() {
      getOptionFundState(this.fundCode).then((res) => {
        if (!res) {
          return;
        }
        if (res.result) {
          // 自选
          this.optionState = true;
        } else {
          this.optionState = false;
        }
      }).catch(() => {
      });
    },
    getFundOptionStateSetAfter() {
      getOptionFundState(this.fundCode).then((res) => {
        if (!res) {
          return;
        }
        if (res.result) {
          // 自选
          this.optionState = true;
        } else {
          this.optionState = false;
        }
      }).catch(() => {
      });
    },
    ssss(name, params, callback) {
      // #if EXECUTION_ENV === 'web'
      console.log(`调用原生${name}方法，参数：`, params);
      // #elif EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (!fundDetail[name]) {
        console.warn(`fundDetail 没有 ${name} 方法`);
        callback(null, '');
        return;
      }
      // eslint-disable-next-line no-undef
      fundDetail[name]({
        ...params,
        success: (res) => {
          console.log('ssssssss1');
          callback(res, null);
        },
        fail: (err) => {
          console.log('ssssssss2');
          callback(err, null);
        },
      });
      // #endif
    },
    setOptionState(add) {
      if (add) {
        // jia
        this.ssss('addOptionFund', {
          fundCodes: [this.fundCode],
        }, (res, err) => {
          if (!err) {
            // console.log(JSON.stringify(res));
            const msg = res.errMsg;
            if (msg) {
              this.$feedback.showToast({ title: msg, duration: 3000 });
            }
            this.getFundOptionStateSetAfter();
          } else {
            // console.log(JSON.stringify(res));
            const msg = res.errMsg;
            if (msg) {
              this.$feedback.showToast({ title: msg, duration: 3000 });
            }
          }
        });
      } else {
        // jian
        deleteOptionFund(this.fundCode).then(() => {
          this.optionState = false;
        }).catch(() => {

        });
        this.reportMonitor({
          eventName: 'pz.btn.szx',
        });
      }
    },
    topOptionFund() {
      // 置顶
      topOptionFund(this.fundCode).then(() => {
        // 操作成功
        this.$feedback.showToast({ title: '设置成功', duration: 3000 });
      }).catch(() => {

      });
    },
    getfundStatus() {
      if (!this.baseInfo) {
        return 5;
      }
      const {
        ISSBDATE, ISSEDATE, BUY, ISSALES,
      } = this.baseInfo;
      if (!ISSBDATE || !ISSEDATE) {
        return 5;
      }
      if (BUY) {
        return 1;
      }

      const startDate = new Date(ISSBDATE.replace(/-/g, '/')).getTime();
      const endDate = new Date(ISSEDATE.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();

      if (endDate > startDate) {
        if (startDate > serverDate) {
          return 0;
        }
        if (endDate >= serverDate) {
          if (ISSALES === '1') {
            return 1;
          }
          return 5;
        }
        return 2;
      }
      return 5;
    },
    jumpToXYPAge() {
      this.jumpToAPPFund();
    },
    nomalBuy() {
      // xinf
      let ishqb = '0';
      const BAGTYPE = JS.fetchString(this.baseInfo, 'BAGTYPE');
      const FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      const FTYPE = JS.fetchString(this.baseInfo, 'FTYPE');
      if (FTYPE.toLowerCase() === 'REITs'.toLowerCase()) {
        this.jumpToXYPAge();
        return;
      }
      if (isEmpty(FCODE)) {
        this.$feedback.showToast({ title: '网络异常，请刷新重试', duration: 3000 });
        return;
      }
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (isEmpty(FCODE)) {
        this.$feedback.showToast({ title: '网络异常，请刷新重试', duration: 3000 });
        return;
      }
      // 直接购买
      this.jumpToBuyAPPFund();
      this.hqbbuyclick(FCODE, ishqb);
    },
    getnewfundcalendarremind() {
      if (this.getfundStatus() === 0) {
        const remtitle = `天天基金开售提醒：${this.fundName}(${this.fundCode})已经开放认购，不要错过啦~`;
        queryCalendarRemind(remtitle).then((res) => {
          if (!res) {
            return;
          }
          if (res.result) {
            this.hadcalendarremind = true;
            this.getSellStateText();
          } else {
            this.hadcalendarremind = false;
            this.getSellStateText();
          }
        }).catch(() => {

        });
      }
    },
    setnewfundcalendarremind() {
      if (this.getfundStatus() === 0) {
        const remtitle = `天天基金开售提醒：${this.fundName}(${this.fundCode})已经开放认购，不要错过啦~`;
        const url = `https://act.1234567.com.cn/topic/repository/fund-toapp-page/openapp.html?schema=fund://page/funddetail?fundcode=${this.fundCode}&IsVerifyLogin=false&LinkType=1`;
        const { ISSBDATE } = this.baseInfo;
        const btime = ISSBDATE.length > 10 ? `${ISSBDATE.substr(0, 10)}` : '';
        const begin = `${btime} 09:00:00`;
        const end = `${btime} 10:00:00`;
        const startDate = new Date(begin.replace(/-/g, '/')).getTime();
        const endDate = new Date(end.replace(/-/g, '/')).getTime();
        // window.alert(begin);
        const param = {
          title: remtitle,
          description: url,
          beginTime: startDate,
          endTime: endDate,
          url,
          delete: '0',
          type: 1,
        };
        setCalendarRemind(param).then((res) => {
          if (!this.checkAndroidANDVersion()) {
            if (res && res.errMsg) {
              this.$feedback.showToast({ title: '需要日历权限为你提供开售提醒服务，请前往设置', duration: 3000 });
              return;
            }
          }
          this.getnewfundcalendarremind();
        }).catch((res) => {
          if (!this.checkAndroidANDVersion()) {
            if (res && res.errMsg) {
              this.$feedback.showToast({ title: '需要日历权限为你提供开售提醒服务，请前往设置', duration: 3000 });
            }
          }
        });
      }
    },
    checkAndroidANDVersion() {
      // eslint-disable-next-line no-undef
      const isAnd = multi.$system.isAndroid;
      // eslint-disable-next-line no-undef
      const version = multi.$system.appVersion;
      console.log(`${isAnd}--------${version}`);
      if (isAnd) {
        if (version >= '6.3.7') {
          return true;
        }
      }
      return false;
    },
    opennewfundcalendarremind() {
      // open
      if (this.getfundStatus() === 0) {
        const remtitle = `天天基金开售提醒：${this.fundName}(${this.fundCode})已经开放认购，不要错过啦~`;
        openCalendarRemind(remtitle).then(() => {
          this.getnewfundcalendarremind();
        }).catch(() => {
          this.getnewfundcalendarremind();
        });
      }
    },
    goNewFundBtnAction() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        if (this.canNewBtnRed) {
          this.jumpToBuyAPPFund();
        } else {
          this.jumpToAPPFund();
        }
        return;
      }
      // #endif
      if (this.sellStateText === '购买') {
        // 新发购买
        if (this.isExchangeFund()) {
          // 场内购买
          this.goCnFundBtnAction();
        } else if (this.canNewBtnRed) {
          this.nomalBuy();
        }
      } else if (this.sellStateText === '查看提醒') {
        // s
        this.needGetDateAlertState = true;
        this.opennewfundcalendarremind();
        this.reportMonitor({
          eventName: 'pz.btn.cktx',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      } else if (this.sellStateText === '开售提醒') {
        // s
        this.needGetDateAlertState = true;
        this.setnewfundcalendarremind();
        this.reportMonitor({
          eventName: 'pz.btn.kstx',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      } else {
        // qqt
      }
    },
    goCnFundBtnAction() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        this.jumpToAPPFund();
        return;
      }
      // #endif
      const FTYPE = JS.fetchString(this.baseInfo, 'FTYPE');
      if (FTYPE.toLowerCase() === 'REITs'.toLowerCase()) {
        this.jumpToXYPAge();
        return;
      }
      // cn
      const LISTTEXCHMARK = JS.fetchString(this.baseInfo, 'LISTTEXCHMARK');
      // const LISTTEXCH = JS.fetchString(this.baseInfo, 'LISTTEXCH');
      let FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      const SHORTNAME = JS.fetchString(this.baseInfo, 'SHORTNAME');
      const REALSGCODE = JS.fetchString(this.baseInfo, 'REALSGCODE');
      if (REALSGCODE) {
        if (REALSGCODE.length > 3) {
          FCODE = REALSGCODE;
        }
      }
      emBuyFund({
        enterID: '3',
        fCode: FCODE,
        fName: SHORTNAME,
        LISTTEXCHMARK,
        LISTTEXCH: LISTTEXCHMARK,
      });
    },
    clickEmpt() {
    },
    clickPk() {
      this.jumpToAPPFund();
    },
    isNomalFund() {
      if (this.isNewFund()) {
        return false;
      }
      if (this.isExchangeFund()) {
        return false;
      }
      return true;
    },
    isNewFund() {
      return FundTypeSearch.isNewFund(this.fundType);
    },
    isExchangeFund() {
      return FundTypeSearch.isExchangeFund(this.fundType);
    },
    tradeFund() {
      this.jumpToAPPFund();
    },
    getOptionABTest() {
      let userBTest = false;
      // #if EXECUTION_ENV === 'fund'
      userBTest = true;
      // #endif
      return userBTest;
    },
    clickSetOption() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        this.jumpToAPPFund();
        return;
      }
      // #endif
      if (this.optionState) {
        // #if EXECUTION_ENV === 'fund'
        // eslint-disable-next-line no-undef
        if (fundDetail.showPortfolioEditDialog && this.getOptionABTest()) {
          if (FundTypeSearch.isMonetaryfund(this.fundType)) {
            this.popupList = ['删自选', '编辑分组', '自选置顶'];
          } else {
            this.popupList = ['删自选', '编辑分组', '设置提醒', '自选置顶'];
          }
          this.showPopup = true;
        } else {
          if (FundTypeSearch.isMonetaryfund(this.fundType)) {
            this.popupList = ['删自选', '自选置顶'];
          } else {
            this.popupList = ['删自选', '设置提醒', '自选置顶'];
          }
          this.showPopup = true;
        }
        // #endif
      } else {
        this.setOptionState(true);
        this.reportMonitor({
          eventName: 'pz.btn.jzx',
          activeParams: JSON.stringify({ productcode: this.fundCode }),
          eventContent: {
            activeParams: JSON.stringify({ productcode: this.fundCode }),
          },
        });
      }
    },
    hidePopup() {
      this.showPopup = false;
    },
    openoptionfundremind() {
      this.jumpToAPPFund();
    },
    async clickPopup(index, item) {
      // ['删自选', '编辑分组', '设置提醒', '自选置顶'];
      if (item === '删自选') {
        this.setOptionState(false);
        this.hidePopup();
        return;
      }
      if (item === '编辑分组') {
        this.hidePopup();
        // #if EXECUTION_ENV === 'fund'
        // eslint-disable-next-line no-undef
        if (fundDetail.showPortfolioEditDialog) {
          const info = await this.$getUserInfo();
          const {
            passportid,
          } = info;
          if (passportid) {
            // eslint-disable-next-line no-undef
            fundDetail.showPortfolioEditDialog({ fCode: this.fundCode });
          } else {
            userLogin().then(() => {
            // eslint-disable-next-line no-undef
              fundDetail.showPortfolioEditDialog({ fCode: this.fundCode });
            }).catch(() => {

            });
          }
        }
        // #endif
        return;
      }
      if (item === '设置提醒') {
        const info = await this.$getUserInfo();
        console.log(info.passportid);
        if (info.passportid && info.passportid.length > 0) {
          this.jumpToAPPFund();
        } else {
          userLogin().then(() => {
          }).catch(() => {
          });
        }
        this.hidePopup();
        return;
      }
      if (item === '自选置顶') {
        this.topOptionFund();
        this.hidePopup();
      }
    },
    clickBar() {
      this.setClickBarGuide();
      // 讨论
      this.jumpToAPPFund();
      this.reportMonitor({
        eventName: 'pz.btn.pl',
      });
    },
    configCFH() {
      const cfhdata = this.$store.state.cfhModules.fund[this.fundCode];
      if (cfhdata) {
        const { cfhinfos } = cfhdata;
        if (cfhinfos && cfhinfos.length > 0) {
          const cfhInfo = cfhinfos[0];
          if (cfhInfo.cfhname) {
            this.cfhName = cfhInfo.cfhname;
            this.cfhID = cfhInfo.cfhid;
            this.cfhLink = {
              LinkType: 2,
              AdId: 0,
              LinkTo: cfhInfo.link.linkTo ? cfhInfo.link.linkTo : '',
            };
            this.cfhImgPath = cfhInfo.headerimgpath;
          }
        }
      }
    },
    getwfstTip() {
      return '万元收益';
    },
    gethqdata() {
      const fundinfo = StoreManger.getFundJJXQ();
      const sData = StoreManger.getFundJJFX();
      let FSRQ = JS.fetchString(fundinfo, 'FSRQ');
      if (FSRQ.length > 5) {
        FSRQ = JS.fetchString(fundinfo, 'FSRQ').substring(5);
      }
      let ISSBDATE = JS.fetchString(fundinfo, 'ISSBDATE');
      if (ISSBDATE.length > 16) {
        ISSBDATE = JS.fetchString(fundinfo, 'ISSBDATE').substring(16);
      }
      let ISSEDATE = JS.fetchString(fundinfo, 'ISSEDATE');
      if (ISSEDATE.length > 11) {
        ISSEDATE = JS.fetchString(fundinfo, 'ISSEDATE').substring(16);
      }
      const FEATURE = JS.fetchString(fundinfo, 'FEATURE');
      const DWJZ = JS.fetchString(fundinfo, 'DWJZ');
      const LJJZ = JS.fetchString(fundinfo, 'LJJZ');
      const SHORTNAME = JS.fetchString(fundinfo, 'SHORTNAME');
      const FCODE = JS.fetchString(fundinfo, 'FCODE');
      const SYL = JS.fetchString(sData, 'SYL');
      const PERIODNAME = JS.fetchString(sData, 'PERIODNAME');
      const ZDFStr = `，${PERIODNAME}${SYL}%`;
      const ZDFWXStr = `\n${PERIODNAME}：${SYL}%`;
      const RZDF = JS.fetchString(sData, 'RZDF');
      const FTYPE = JS.fetchString(fundinfo, 'FTYPE');
      const MINRG = JS.fetchString(fundinfo, 'MINRG');
      const data = {
        FSRQ,
        DWJZ,
        LJJZ,
        SHORTNAME,
        FCODE,
        FEATURE,
        ISSEDATE,
        ISSBDATE,
        ZDFStr,
        RZDF,
        FTYPE,
        MINRG,
        ZDFWXStr,
      };
      this.shareDate = data;
    },
    hbShareScript() {
      let midStr = `，${this.shareDate.FSRQ}${this.getwfstTip()}为${this.shareDate.DWJZ}`;
      if (this.shareDate.DWJZ === '--') {
        midStr = '';
      }
      let lastStr = `，7日年化${parseFloat(this.shareDate.LJJZ).toFixed(4)}%`;
      if (this.shareDate.LJJZ === '--') {
        lastStr = '';
      }
      return `//我刚刚在天天基金手机端关注了一只货币基金：${this.shareDate.SHORTNAME}（${this.shareDate.FCODE}）${midStr}${lastStr}。随时随地买基金、查净值就用天天基金。`;
    },
    nfShareScript() {
      const zhouqi = `，认购期是${this.shareDate.ISSBDATE}~${this.shareDate.ISSEDATE}`;
      return `//我刚刚在天天基金手机端关注了新基金：${this.shareDate.SHORTNAME}（${this.shareDate.FCODE}） ${zhouqi}。随时随地买基金、查净值就用天天基金。`;
    },
    cnShareScript() {
      const mid = `，${this.shareDate.FSRQ}净值为${this.shareDate.DWJZ}（${this.shareDate.RZDF}%)`;
      return `//我刚刚在天天基金手机端关注了一只场内基金：${this.shareDate.SHORTNAME}（${this.shareDate.FCODE}）${mid}${this.shareDate.ZDFStr}。`;
    },
    pgShareScript() {
      const mid = `，${this.shareDate.FSRQ}净值为${this.shareDate.DWJZ}（${this.shareDate.RZDF}%)`;
      return `//我刚刚在天天基金手机端关注了一只股基：${this.shareDate.SHORTNAME}（${this.shareDate.FCODE}）${mid}${this.shareDate.ZDFStr}。`;
    },
    hbWxShareScript() {
      const mid = `\n${this.getwfstTip()}：${this.shareDate.DWJZ}（${this.shareDate.FSRQ}）`;
      const lastStr = `\n七日年化：${parseFloat(this.shareDate.LJJZ).toFixed(4)}%`;
      return `基金类型：${this.shareDate.FTYPE}${mid}${lastStr}`;
    },
    nfWxShareScript() {
      const mid = `\n认购期:${this.shareDate.ISSBDATE}~${this.shareDate.ISSEDATE}`;
      const lastStr = `\n最低认购：${this.shareDate.MINRG}元`;
      return `基金类型：${this.shareDate.FTYPE}${mid}${lastStr}`;
    },
    cnWxShareScript() {
      return this.pgWxShareScript();
    },
    pgWxShareScript() {
      const mid = `\n最新净值：${this.shareDate.DWJZ}（${this.shareDate.RZDF}%）`;
      const lastStr = `${this.shareDate.ZDFWXStr}`;
      return `基金类型：${this.shareDate.FTYPE}${mid}${lastStr}`;
    },
    getcfhtip() {
      return '';
    },
    getBottomGuidText() {
      // 获取指引文字
      // const cacheData = this.$store.state.fcache;

      if (this.getcfhtip().length > 0) {
        return this.getcfhtip();
      }

      const fundinfo = StoreManger.getFundJJXQ();
      const hqkey = `${this.fundCode}hqcaheTime`;
      if (fundinfo) {
        const zdf = JS.fetchString(fundinfo, 'RZDF');
        const fture = JS.fetchString(fundinfo, 'FEATURE');
        if (fundinfo.LINKZSB === '1') {
          // 指数 7天
          if (this.getCache(hqkey)) {
            const timestamp = new Date().getTime();
            if ((timestamp - this.getCache(hqkey)) < (24 * 60 * 60 * 7 * 1000)) {
              return '';
            }
          }
          if (fture.indexOf('050') !== -1 || fture.indexOf('318') !== -1) {
            const zszdf = JS.fetchString(fundinfo, 'SYL_Z');
            if (this.getUptoValue(zszdf, 5.0)) {
              return `周涨幅${parseFloat(zszdf).toFixed(2)}%，来看看涨跌分析`;
            }
          }
          return '';
        }
        // 普通 一天
        if (this.getCache(hqkey)) {
          const timestamp = new Date().getTime();
          if ((timestamp - this.getCache(hqkey)) < (24 * 60 * 60 * 1 * 1000)) {
            return '';
          }
        }
        if (this.getUptoValue(zdf, 3.0)) {
          return `日涨幅${parseFloat(zdf).toFixed(2)}%，来看看涨跌分析`;
        }
        return '';
      }
      return '';
    },
    getShowZDFX() {
      const fundinfo = StoreManger.getFundJJXQ();
      if (fundinfo) {
        const zdf = JS.fetchString(fundinfo, 'RZDF');
        const fture = JS.fetchString(fundinfo, 'FEATURE');
        if (fundinfo.LINKZSB === '1') {
          // 指数 7天
          if (fture.indexOf('050') !== -1 || fture.indexOf('318') !== -1) {
            const zszdf = JS.fetchString(fundinfo, 'SYL_Z');
            if (this.getUptoValue(zszdf, 5.0)) {
              return `周涨幅${parseFloat(zszdf).toFixed(2)}%，来看看涨跌分析`;
            }
          }
          return '';
        }
        if (this.getUptoValue(zdf, 3.0)) {
          return `日涨幅${parseFloat(zdf).toFixed(2)}%，来看看涨跌分析`;
        }
        return '';
      }
      return '';
    },
    getUptoValue(value, max) {
      if (!value) {
        return false;
      }
      if (value === '--') {
        return false;
      }
      if (parseFloat(value) > max) {
        return true;
      }
      if ((0 - parseFloat(value)) > max) {
        return true;
      }
      return false;
    },
    setClickBottomGuid() {
      this.showGuid = false;
      // 设置提醒过期
      if (this.getcfhtip().length > 0 && this.cfhtipKey.length > 0) {
        this.setCache(this.cfhtipKey, '1');
        return true;
      }
      if (this.getBottomGuidText().length > 0) {
        const hqkey = `${this.fundCode}hqcaheTime`;
        const timestamp = new Date().getTime();
        this.setCache(hqkey, timestamp);
        return true;
      }
      return false;
    },
    clickShowMore() {
      const fundinfo = StoreManger.getFundJJXQ();
      this.setClickBottomGuid();
      const FCODE = JS.fetchString(fundinfo, 'FCODE');
      const SHORTNAME = JS.fetchString(fundinfo, 'SHORTNAME');
      this.configCFH();
      this.gethqdata();
      const cfhimage = this.cfhImgPath.length > 0 ? this.cfhImgPath : cfhmr;
      const jgjdlink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/7be9fe8d23404e658637288726244df5/pages/PreviousFundInterpret?fundcode=${FCODE}&fundname=${SHORTNAME}` };
      const twLink = { LinkType: '1', LinkTo: `fund://page/questionPost?fundCode=${FCODE}` };
      const ftLink = { LinkType: '1', LinkTo: `fund://page/barPost?fundCode=${FCODE}` };
      const bzLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/SelfFundDynamicHome?fundCode=${FCODE}&fundName=${SHORTNAME}` };
      let znzlLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?pageFundCode=${FCODE}` };
      let xzx = '';
      // 涨跌分析
      const tip = this.getShowZDFX();
      if (tip.length > 0) {
        if (this.getCache(`fundBottomZNZL${FCODE}`)) {
          if (this.getCache(`fundBottomZNZL${FCODE}`) !== tip) {
            xzx = '涨跌分析';
            znzlLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=${SHORTNAME}的涨跌分析` };
          }
        } else {
          xzx = '涨跌分析';
          znzlLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=${SHORTNAME}的涨跌分析` };
        }
      }
      let pztip = '';
      if (this.getCache('pztpkey') !== '1') {
        pztip = '1';
      }
      const dtjsqLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/d211f561b9854076a8d9db96d6a0b065/pages/targetCalculateEntrance?SHORTNAME=${SHORTNAME}&FCODE=${FCODE}` };
      const zdLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=${SHORTNAME}(${FCODE})基金诊断&` };
      const list = [
        {
          name: '财富号', image: cfhimage, link: this.cfhLink, tip: this.cfhtip, redpoint: '',
        },
        {
          name: '机构解读', image: jgjd, link: jgjdlink, tip: '', redpoint: '',
        },
        {
          name: '提问', image: twpng, link: twLink, tip: '', redpoint: '',
        },
        {
          name: '发帖', image: ft, link: ftLink, tip: '', redpoint: '',
        },
        {
          name: '备注', image: bz, link: bzLink, tip: '', redpoint: pztip,
        },
        {
          name: '智能助理', image: znzl, link: znzlLink, tip: xzx, redpoint: '',
        },
      ];
      if (FundTypeSearch.isNewFund(this.fundType)
      || FundTypeSearch.isMonetaryfund(this.fundType)
      || FundTypeSearch.isExchangeFund(this.fundType)
      || FundTypeSearch.isBondFund(this.fundType)
      || (!this.getFundZhdt())) {
        // wu
      } else {
        list.push({
          name: '定投计算器', image: dtjsj, link: dtjsqLink, tip: '', redpoint: '',
        });
      }
      list.push({
        name: '诊断', image: zd, link: zdLink, tip: '', redpoint: '',
      });
      list.push({
        name: '分享', image: fx, link: {}, tip: '', redpoint: '',
      });
      this.popupMoreList = list;
      this.showMainPopup = true;
      this.reportMonitor({
        eventName: 'pz.btn.more',
      });
    },
    shareClick() {
      const fundinfo = StoreManger.getFundJJXQ();
      const FCODE = JS.fetchString(fundinfo, 'FCODE');
      const SHORTNAME = JS.fetchString(fundinfo, 'SHORTNAME');
      this.configCFH();
      this.gethqdata();
      let shareStr = `//我刚刚在天天基金手机端关注了一只股基：${SHORTNAME}（${FCODE}）`;
      let shareWXStr = `//我刚刚在天天基金手机端关注了一只股基：${SHORTNAME}（${FCODE}）`;
      const isExchangeFund = FundTypeSearch.isExchangeFund(this.fundType);
      const isNewFund = FundTypeSearch.isNewFund(this.fundType);
      const isMonetaryfund = FundTypeSearch.isMonetaryfund(this.fundType);
      if (isExchangeFund) {
        shareStr = this.cnShareScript();
        shareWXStr = this.cnWxShareScript();
      } else if (isNewFund) {
        shareStr = this.nfShareScript();
        shareWXStr = this.nfWxShareScript();
      } else if (isMonetaryfund) {
        shareStr = this.hbShareScript();
        shareWXStr = this.hbWxShareScript();
      } else {
        shareStr = this.pgShareScript();
        shareWXStr = this.pgWxShareScript();
      }
      const shareData = {
        caifuhaoId: this.cfhID,
        shareImageUrl: '',
        shareViewScence: `https://m.1234567.com.cn/index.html?page=jjxq&code=${FCODE}`,
        title: `${SHORTNAME}  ${FCODE}`,
        commonDescribe: shareStr,
        customDescribe: shareWXStr,
        fCode: FCODE,
        fName: SHORTNAME,
        caifuhaoName: this.cfhName,
        caifuhaoLink: this.cfhLink,
        caifuhaoImageUrl: this.cfhImgPath ? this.cfhImgPath : '',
        wxMiniWebpageUrl: '',
        wxMiniUserName: 'gh_867a85026c3c',
        wxMiniPath: `/pages/fund-detail/index?id=${FCODE}`,
      };
      shareFundDetail(shareData);
    },
    hideMorePopup() {
      this.showMainPopup = false;
    },
    cancelPopup() {
      this.reportMonitor({
        eventName: 'pz.btn.more.cancel',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickMorePopup(item) {
      if (item.name === '分享') {
        // #if EXECUTION_ENV == 'web'
        // eslint-disable-next-line no-undef
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
          this.jumpToAPPFund();
          return;
        }
        // #endif
        // fx
        setTimeout(() => {
          this.shareClick();
        }, 1000);
      } else if (item.name === '财富号') {
        // fx
        if (this.cfhName.length > 0 && this.cfhID.length > 0) {
          this.setCache(this.cfhtipmoreKey, '1');
          this.jumpToAPPFund();
        } else {
          this.$feedback.showToast({ title: '当前基金公司暂未开通财富号', duration: 3000 });
        }
      } else {
        if (item.tip === '涨跌分析') {
          // 涨跌分析
          const tip = this.getShowZDFX();
          this.setCache(`fundBottomZNZL${this.fundCode}`, tip);
        }
        if (item.name === '备注') {
          // 备注
          this.setCache('pztpkey', '1');
        }
        if (item.name === '提问') {
          // #if EXECUTION_ENV == 'web'
          // eslint-disable-next-line no-undef
          const webPlatf = multi.$system.webPlatform;
          if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
            this.jumpToAPPFund();
            return;
          }
          // #endif
          // 问答
          userLogin().then(() => {
            this.jumpToAPPFund();
          }).catch(() => {

          });
        } else {
          this.jumpToAPPFund();
        }
      }
      if (item.name === '备注') {
        this.reportMonitor({
          eventName: 'pzy.gd.bz.click',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '机构解读') {
        this.reportMonitor({
          eventName: 'pz.btn.more.jgjd',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '发帖') {
        this.reportMonitor({
          eventName: 'pz.btn.more.ft',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '提问') {
        this.reportMonitor({
          eventName: 'pz.btn.more.tw',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '智能助理') {
        this.reportMonitor({
          eventName: 'pz.btn.more.zlnormal',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '定投计算器') {
        this.reportMonitor({
          eventName: 'pz.btn.more.dtjsq',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '诊断') {
        this.reportMonitor({
          eventName: 'pz.btn.more.diagnose',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '分享') {
        this.reportMonitor({
          eventName: 'pz.btn.more.share',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
      if (item.name === '财富号') {
        this.reportMonitor({
          eventName: 'pz.btn.more.cfh',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
    },
    getFundZhdt() {
      const fundinfo = StoreManger.getFundJJXQ();
      const BFUNDTYPE = JS.fetchString(fundinfo, 'BFUNDTYPE');
      const DTZT = JS.fetchString(fundinfo, 'DTZT');
      if (BFUNDTYPE === '001' || BFUNDTYPE === '002' || BFUNDTYPE === '007') {
        if (DTZT) {
          return true;
        }
      }
      return false;
    },
    buyAndFixType() {
      const fundinfo = StoreManger.getFundJJXQ();
      const BACKCODE = JS.fetchString(fundinfo, 'BACKCODE');
      const QDTCODE = JS.fetchString(fundinfo, 'QDTCODE');
      if (BACKCODE.length > 3 && QDTCODE.length > 3) {
        return 'TypeGBDFD';
      }
      if (BACKCODE.length > 3) {
        return 'TypeGBD';
      }
      if (QDTCODE.length > 3) {
        return 'TypeGDFD';
      }
      return 'TypeGD';
    },
    getshowListModule(Modules, code, needSuitScene) {
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter(
            (item) => (item.Text === needSuitScene),
          );
          return CustomArray;
        }
      }
      return [];
    },
    getzhdtqblink() {
      const qblinkto = {
        LinkType: '2',
        LinkTo: 'https://topic.1234567.com.cn/html/2019/10/23/zhdtptdt.html?spm=cpyy.ChenYuanYuan.gn',
      };
      return qblinkto;
    },
    getfixedTipTitleList(isDt) {
      const fundinfo = StoreManger.getFundJJXQ();
      if (isDt) {
        const QDTCODE = JS.fetchString(fundinfo, 'QDTCODE');
        const zhdtItem = {
          name: '了解普通定投与智能定投的区别',
          link: this.getzhdtqblink(),
        };
        const qdtItem = {
          name: '什么是强定投',
          link: {
            LinkType: '2',
            LinkTo: 'https://helpmob.1234567.com.cn/m/q_970.html?&rand=',
          },
        };
        if (this.getFundZhdt() && QDTCODE.length > 3) {
          // 支持智能定投和强定投
          return [zhdtItem, qdtItem];
        }
        if (this.getFundZhdt()) {
          // 支持智能定投和强定投
          return [zhdtItem];
        }
        if (QDTCODE.length > 3) {
          // 支持智能定投和强定投
          return [qdtItem];
        }
        return [];
      }
      const BACKCODE = JS.fetchString(fundinfo, 'BACKCODE');
      if (BACKCODE.length > 3) {
        const hdyqdItem = {
          name: '前端购买和后端购买的区别',
          link: {
            LinkType: '2',
            LinkTo: 'https://helpmob.1234567.com.cn/m/q_548.html?&rand=',
          },
        };
        return [hdyqdItem];
      }
      return [];
    },
    canForceFixed() {
      const fundinfo = StoreManger.getFundJJXQ();
      const QDTCODE = JS.fetchString(fundinfo, 'QDTCODE');
      if (QDTCODE.length > 3) {
        return true;
      }
      return false;
    },
    getBuyPoint() {
      const fundinfo = StoreManger.getFundJJXQ();
      const ISSALES = JS.fetchString(fundinfo, 'ISSALES');
      const MINSG = JS.fetchString(fundinfo, 'MINSG');
      if (ISSALES === '1' && MINSG.length > 0) {
        return `${parseFloat(MINSG).toFixed(0)}元起`;
      }
      return '';
    },
    getFixedPoint() {
      const fundinfo = StoreManger.getFundJJXQ();
      const DTZT = JS.fetchString(fundinfo, 'DTZT');
      const MINDT = JS.fetchString(fundinfo, 'MINDT');
      if (DTZT === '1' && MINDT.length > 0) {
        return `${parseFloat(MINDT).toFixed(0)}元起`;
      }
      return '';
    },
    async clickBuy() {
      const ishod = this.isHold;
      const fundinfo = StoreManger.getFundJJXQ();
      let ishqb = '0';
      const BAGTYPE = JS.fetchString(fundinfo, 'BAGTYPE');
      let FCODE = JS.fetchString(fundinfo, 'FCODE');
      const REALSGCODE = JS.fetchString(fundinfo, 'REALSGCODE');
      if (REALSGCODE) {
        if (REALSGCODE.length > 3) {
          FCODE = REALSGCODE;
        }
      }
      const MINSG = JS.fetchString(fundinfo, 'MINSG');
      const MINSBSG = JS.fetchString(fundinfo, 'MINSBSG');
      let buyname = `购买(前端:${FCODE})`;
      let buypoint = this.getBuyPoint();
      if (ishod) {
        if (MINSG !== MINSBSG) {
          buyname = '追加买入';
          buypoint = `${parseFloat(MINSBSG).toFixed(0)}元起`;
        }
      }
      const FTYPE = JS.fetchString(this.baseInfo, 'FTYPE');
      if (FTYPE.toLowerCase() === 'REITs'.toLowerCase()) {
        this.jumpToXYPAge();
        return;
      }
      if (isEmpty(FCODE)) {
        this.$feedback.showToast({ title: '网络异常，请刷新重试', duration: 3000 });
        return;
      }
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (isEmpty(FCODE)) {
        this.$feedback.showToast({ title: '网络异常，请刷新重试', duration: 3000 });
        return;
      }
      const buyLink = {
        LinkType: '1',
        LinkTo: `fund://page/buyfund?fundcode=${FCODE}&tagtype=${ishqb}`,
      };
      const BACKCODE = JS.fetchString(fundinfo, 'BACKCODE');
      const bbuyLink = {
        LinkType: '1',
        LinkTo: `fund://page/buyfund?fundcode=${BACKCODE}&tagtype=${ishqb}`,
      };
      if (BACKCODE.length > 3) {
        const buyItem = {
          name: buyname,
          tip: '',
          subName: buypoint,
          link: buyLink,
        };
        if (ishqb === '1') {
          buyItem.clickpoint = {
            eventName: 'pz.hqb.gman.click',
            infoCodeType: '5',
            infoCode: FCODE,
          };
        }
        this.popupBuyList = [
          buyItem,
          {
            name: `购买(后端:${BACKCODE})`,
            tip: '',
            subName: this.getBuyPoint(),
            link: bbuyLink,
          },
        ];
        this.popupBuyTitle = this.getfixedTipTitleList(false);
        this.showbuyPopup = true;
      } else {
        // 直接购买
        this.jumpToBuyAPPFund();
        this.hqbbuyclick(FCODE, ishqb);
      }
    },
    wxmobuy() {
      const buyUrl = `https://h5.1234567.com.cn/app/trade/buyfund?code=${this.fundCode}`;
      const hqbBuyUrl = 'https://h5.1234567.com.cn/app/cashbag/index.html#goPage=rechargeFundList&lastPage=quick';
      const loginUrl = 'https://h5.1234567.com.cn/app/trade/login';
      const cToken = localStorage.getItem('EastMoney.TTFund.CashBag.cToken');
      const uToken = localStorage.getItem('EastMoney.TTFund.CashBag.uToken');
      console.log(`${cToken}------------${uToken}`);
      let targetUrl = '';

      let ishqb = '0';
      const BAGTYPE = JS.fetchString(this.baseInfo, 'BAGTYPE');
      if (BAGTYPE === '1') {
        ishqb = '1';
      }

      const goNext = () => {
        this.jumpToBuyAPPFund();
      };

      if (cToken && uToken) {
        const isVisitor = localStorage.getItem('EastMoney.TTFund.TradeApi.IsVisitor');
        // 判断实名认证,登录之后记缓存
        if (isVisitor === 'true') {
          this.$feedback.showModal({
            content: '你还没有完成实名认证，请先前往天天基金App完成实名绑卡再次尝试。',
            // 隐藏取消按钮
            showCancel: false,
            confirmText: '知道了',
            confirmColor: '#f40',
          });
          return;
        }

        // 活期宝基金
        if (ishqb === '1') {
          // targetUrl = hqbBuyUrl;
          this.$feedback.showModal({
            content: '当前基金是“活期宝”所属产品，活期宝是天天基金推出的一款优选货币基金的理财工具。',
            confirmText: '去充值',
            success(res) {
              // 用户点击确定
              if (res.confirm) {
                goNext(hqbBuyUrl);
              // 用户点击取消
              } else if (res.cancel) {
                // console.log('用户点击取消');
              }
            },
          });
        // 普通基金
        } else {
          // targetUrl = buyUrl;
          goNext(buyUrl);
        }
      } else {
        let tempUrl = '';
        tempUrl = this.specialFundType === '1' ? hqbBuyUrl : buyUrl;
        targetUrl = `${loginUrl}?backurl=${encodeURIComponent(tempUrl)}`;
        goNext(targetUrl);
      }
    },
    clickShowBuy() {
      this.checkAndroidANDVersion();
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      console.log(webPlatf);
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        // this.wxmobuy();
        if (this.canClickBuy) {
          this.jumpToBuyAPPFund();
        } else {
          this.jumpToAPPFund();
        }
        return;
      }
      // #endif
      if (!this.canClickBuy) {
        return;
      }
      userLogin().then(() => {
        this.clickBuy();
      }).catch(() => {

      });

      const FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      this.reportMonitor({
        eventName: 'pz.btn.buy',
        infoCodeType: '5',
        infoCode: FCODE,
      });
    },
    clickFixed() {
      const QDTCODE = JS.fetchString(this.baseInfo, 'QDTCODE');
      const FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      const SHORTNAME = JS.fetchString(this.baseInfo, 'SHORTNAME');
      const BACKCODE = JS.fetchString(this.baseInfo, 'BACKCODE');
      let ym = 'https://gaoduanmob.1234567.com.cn';
      let userBTest = true;
      const abtest = 'B';
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      const appEnv = systemInfo.appEnvironment;
      if (appEnv === 2 || appEnv === '2') {
        ym = 'http://gaoduanmobtest.1234567.com.cn';
        userBTest = true;
      } else if (appEnv === 1 || appEnv === '1') {
        userBTest = true;
        ym = 'https://gaoduanmobtest2.1234567.com.cn';
      }
      // #endif

      const zhdturl = `${ym}/Weex/WisdomPeriodTrade/strategyList.weex.js?code=${FCODE}&name=${SHORTNAME}`;
      let zfixedLink = {
        LinkType: '2',
        LinkTo: `${ym}/Web/WisdomPeriodTrade/strategyList.html?_wx_tpl=${encodeURIComponent(zhdturl)}`,
      };
      let fixLink = {
        LinkType: '2',
        LinkTo: `fund://mp.1234567.com.cn/weex/f00e556737aa44f9991808035186ab87/pages/depositTrade?code=${FCODE}`,
      };
      let qfixLink = {
        LinkType: '2',
        LinkTo: `fund://mp.1234567.com.cn/weex/f00e556737aa44f9991808035186ab87/pages/depositTrade?code=${QDTCODE}`,
      };
      if (userBTest) {
        zfixedLink = {
          LinkType: '2',
          // LinkTo: `fund://mp.1234567.com.cn/weex/8eb1018f5ca847b4b8e3741cd10be65e/pages/strategy/strategyList?code=${FCODE}&name=${SHORTNAME}`,
          LinkTo: `fund://mp.1234567.com.cn/weex/8eb1018f5ca847b4b8e3741cd10be65e/pages/tradePage/newBuyDT/buyDTCreatePage?code=${FCODE}&dtType=1`,
        };
        fixLink = {
          LinkType: '2',
          // LinkTo: `fund://mp.1234567.com.cn/weex/8eb1018f5ca847b4b8e3741cd10be65e/pages/tradePage/normalDT/normalDTCreatePage?code=${FCODE}`,
          LinkTo: `fund://mp.1234567.com.cn/weex/8eb1018f5ca847b4b8e3741cd10be65e/pages/tradePage/newBuyDT/buyDTCreatePage?code=${FCODE}&dtType=0`,
        };
        qfixLink = {
          LinkType: '2',
          // LinkTo: `fund://mp.1234567.com.cn/weex/8eb1018f5ca847b4b8e3741cd10be65e/pages/tradePage/normalDT/normalDTCreatePage?code=${QDTCODE}`,
          LinkTo: `fund://mp.1234567.com.cn/weex/8eb1018f5ca847b4b8e3741cd10be65e/pages/tradePage/newBuyDT/buyDTCreatePage?code=${QDTCODE}&dtType=2`,
        };
      }

      let ptdt = '普通定投';
      if (BACKCODE.length > 3) {
        ptdt = '普通定投（前端）';
      }

      let zndt = '智能定投';
      if (BACKCODE.length > 3) {
        zndt = '智能定投（前端）';
      }

      if (QDTCODE.length > 3 && this.getFundZhdt()) {
        this.popupBuyList = [
          {
            name: ptdt,
            clickpoint: {
              eventName: 'pz.buy.dt.normdt',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            cancelclickpoint: {
              eventName: 'pz.buy.dt.qx',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            tip: '',
            subName: this.getFixedPoint(),
            link: fixLink,
          },
          {
            name: zndt,
            clickpoint: {
              eventName: 'pz.buy.dt.zxdt',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            tip: '推荐',
            subName: this.getFixedPoint(),
            link: zfixedLink,
          },
          {
            name: '强定投',
            tip: '',
            subName: this.getFixedPoint(),
            link: qfixLink,
          },
        ];
        this.popupBuyTitle = this.getfixedTipTitleList(true);
        this.showbuyPopup = true;
      } else if (QDTCODE.length > 3) {
        this.popupBuyList = [
          {
            name: ptdt,
            clickpoint: {
              eventName: 'pz.buy.dt.normdt',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            cancelclickpoint: {
              eventName: 'pz.buy.dt.qx',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            tip: '',
            subName: this.getFixedPoint(),
            link: fixLink,
          },
          {
            name: '强定投',
            tip: '',
            subName: this.getFixedPoint(),
            link: qfixLink,
          },
        ];
        this.popupBuyTitle = this.getfixedTipTitleList(true);
        this.showbuyPopup = true;
      } else if (this.getFundZhdt()) {
        const fundinfo = StoreManger.getFundJJXQ();
        let ptdtY = fundinfo.PTDT_Y;
        let dwdtY = fundinfo.DWDT_Y;
        let ptdtSub = '';
        let zndtSub = '';
        if (ptdtY === '--' || dwdtY === '--' || (ptdtY <= 5 && dwdtY <= 5)) {
          ptdtY = null;
          dwdtY = null;
          ptdtSub = '分散投资，跨越周期，摊薄成本';
          zndtSub = '拉低多买，摊薄成本，达到目标收益，回撤后自动止盈';
        } else {
          // ptdtY = `${parseFloat(ptdtY).toFixed(2)}`;
          // dwdtY = `${parseFloat(dwdtY).toFixed(2)}`;
          ptdtSub = '近1年定投收益率';
          zndtSub = '近1年定投收益率';
        }
        this.popupBuyList = [
          {
            name: ptdt,
            clickpoint: {
              eventName: 'pz.buy.dt.normdt',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            cancelclickpoint: {
              eventName: 'pz.buy.dt.qx',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            tip: '',
            subName: ptdtSub,
            dt_y: ptdtY,
            link: fixLink,
          },
          {
            name: zndt,
            clickpoint: {
              eventName: 'pz.buy.dt.zxdt',
              infoCodeType: '5',
              infoCode: FCODE,
              ABTest: abtest,
              eventContent: {
                ABTest: abtest,
              },
            },
            tip: '推荐',
            subName: zndtSub,
            dt_y: dwdtY,
            link: zfixedLink,
          },
        ];
        this.popupBuyTitle = this.getfixedTipTitleList(true);
        this.showbuyPopup = true;
      } else {
        // 直接购买
        this.jumpToBuyAPPFund();
        this.reportMonitor({
          eventName: 'pz.buy.dt.normdt',
          infoCodeType: '5',
          infoCode: FCODE,
          ABTest: abtest,
          eventContent: {
            ABTest: abtest,
          },
        });
      }
    },
    clickShowFixed() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        this.jumpToAPPFund();
        return;
      }
      // #endif
      if (this.canFixedBuy) {
        userLogin().then(() => {
          this.clickFixed();
        }).catch(() => {

        });
      }
      this.reportMonitor({
        eventName: 'pz.buy.dt',
      });
    },
    hideBuyPopup() {
      this.showbuyPopup = false;
    },
    clickBuyPopup() {
    },
    configureAlertState() {
      if (this.needGetDateAlertState) {
        this.getnewfundcalendarremind();
      }
    },
    hideRESPopup() {
      this.resbottomView = false;
    },
    clickResTip() {
      this.jumpToAPPFund();
    },
    clickResTip2() {
      this.jumpToAPPFund();
    },
    clickResComfirm() {
      // xinf
      let ishqb = '0';
      const BAGTYPE = JS.fetchString(this.baseInfo, 'BAGTYPE');
      const FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (isEmpty(FCODE)) {
        this.$feedback.showToast({ title: '网络异常，请刷新重试', duration: 3000 });
        return;
      }
      // 直接购买
      this.jumpToBuyAPPFund();
      this.hqbbuyclick(FCODE, ishqb);
    },
    cancelRes() {

    },
    hqbbuyclick(FCODE, ishqb) {
      if (ishqb === '1') {
        this.reportMonitor({
          eventName: 'pz.hqb.gman.click',
          infoCodeType: '5',
          infoCode: FCODE,
        });
      }
    },
    // jumpMarketChannel() {
    //   if (window.fd_marketChannel && window.fd_marketChannel.length > 0) {

    //   }
    // },
  },
};
</script>

<style scoped lang="less">
  .module-wrapper-wap{
    border-top: 1px solid #eeeeee;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2000;
  }
  .module-wrapper {
    border-top: 1px solid #eeeeee;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99999;
  }

  .rate-tip {
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;

    span {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #333333;
      text-align: center;
      line-height: 24px;

      &:nth-child(2) {
        text-decoration: line-through;
        margin-right: 15px;
      }
    }
  }

  .panel {
    display: flex;
    margin-right: 20px;
  }

  .main-button {
    font-family: PingFangSC-Regular;
    font-size: 34px;
    color: #FFFFFF;
    text-align: center;
    height: 80px;
    align-items: center;
    line-height: 80px;
    width: 155px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .buy-button {
    .main-button;
    border-radius: 0 40px 40px 0;
    margin-right: 10px;
  }

  .invest-button {
    .main-button;
    border-radius: 40px 0 0 40px;
    margin-left: 10px;
  }

  .right-buttons {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }

  .right-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    position: relative;
  }

  .button-icon {
    width: 42px;
    height: 42px;
    margin-bottom: 8px;
  }
  .spline {
    width: 1px;
    background: #ffffff;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .button-label {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #333333;
    text-align: center;
    line-height: 20px;
  }

  .red-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #FF4400;
    position: absolute;
    top: 16px;
    right: 20px;
  }
  .buy_single_text_content {
    font-family: PingFangSC-Regular;
    font-size: 34px;
    color: #FFFFFF;
    text-align: center;
    height: 80px;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 10px;
    margin-right: 10px;
    align-items: center;
    line-height: 80px;
    width: 310px;
    border-radius: 40px;
  }
  .userGuide{
    position: absolute;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    bottom: 100px;
  }
  .userGuideTri{
    position: absolute;
    width: 42px;
    height: 12px;
    left: 160px;
    bottom: 14px;
  }
  .userGuideSep{
    height: 25px;
  }
  .userGuideCont{
    z-index: 99;
    background: #FF6434;
    border-radius: 32px;
    height: 64px;
    min-width: 400px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .userGuideText{
    padding-left: 30px;
    padding-right: 30px;
    font-size: 24px;
    color: #ffffff;
    line-height: 36px;
  }
  .mask {
    position: fixed;
    z-index: 2001;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .5s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(800px);
    opacity: 1;
  }

  .fade-enter-active{
    transition: all .5s ease;
  }
  .fade-enter /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(100px);
    opacity: 1;
  }
  .rxe_tip{
    margin-left: 20px;
  }
  .webbottom{
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 215px;
  }
  .webbottom-button{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ff4400;
    border-radius: 40px;
    padding: 0px 40px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #ff4400;
  }
</style>
